// The teachers page's "Link a different staff record" menu. Until something is
// typed it offers only Remove and the likely rows (TeacherData::SeasonTeacherList
// #candidate_ids: a reasonable name fit with a picture this season or last).
// Typing searches every staff row, for the teacher whose picture is filed under
// another name. Hoover Elementary, 2026-10-28: the menu listed all 587 staff
// rows under the one likely name.
export const SEARCH_MIN = 2;

export const REMOVE = { value: '', label: 'Remove' };

export const linkOptions = ({
  staff, candidateIds, input, toOption,
}) => {
  const likelyIds = new Set(candidateIds || []);
  const likely = staff.filter((s) => likelyIds.has(s.id)).map(toOption);
  const groups = [REMOVE];
  if (likely.length) groups.push({ label: `Likely (${likely.length})`, options: likely });

  if ((input || '').trim().length >= SEARCH_MIN) {
    groups.push({ label: 'All staff', options: staff.filter((s) => !likelyIds.has(s.id)).map(toOption) });
  } else {
    groups.push({
      label: likely.length ? 'Someone else?' : 'No likely staff record',
      options: [{ value: '__search_hint', label: 'Type a name to search all staff', isDisabled: true }],
    });
  }
  return groups;
};
